const Group = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "groupType": 'نوع المجموعة',
    "parentGroup": "المجموعة الأم",
    "search": "بحث",

    // PAGE HEADER
    "group": "مجموعة",

    // ERROR
    "error_name": "أدخل الاسم",
    "error_desc": "أدخل الوصف",
    "error_status": "اختر الحالة",
    "error_grouptype": "اختر نوع المجموعة",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_description": "الوصف",
    "table_group_type": "نوع المجموعة",
    "table_status": "الحالة",

}

export default Group;